export default __webpack_public_path__ + "static/media/Book2.cbdb7563.pdf";